import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '@env/environment';

export class AuthInterceptor implements HttpInterceptor {
  public intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const token = localStorage.getItem(environment.bearerToken);
    if (token) {
      request = request.clone({
        headers: request.headers.set('Authorization', `Bearer ${JSON.parse(token)}`)
      });
    }

    return next.handle(request);
  }
}
